
const debug = false
// const debug = "projectConvert_checkPageAndConfirm"

export default function projectConvert_checkPageAndConfirm(projectIds : ID[]) {
    return new Promise((resolve, reject) => {
        const showWarning = _.some(projectIds, projectId=>{
            const project = gd.session.projects.get(projectId)

            debug && console.log(debug, 'process some', projectId, project)

            return project?.isPage
        })

        debug && console.log(debug, 'process', showWarning, projectIds)

        if (!showWarning) {
            resolve(true)
            return
        }

        gd.modals.confirm.genericText('Convert page','Are you sure you want to convert Page? This action cannot be reverted.', () => {
            gd.modal.hide()
            resolve(true)
        }, {
            yesBtnLabel : 'Yes, proceed',
            onNoCallback: reject
        })
    })
}